'use client'

import { clientLogger } from '@/lib/client/logger'
import type { LogLevel } from '@/types/log'

type ConsoleMethod = 'log' | 'info' | 'warn' | 'error' | 'debug'

type ConsoleLike = Pick<Console, ConsoleMethod>

const methodToLevel: Record<ConsoleMethod, LogLevel> = {
	log: 'info',
	info: 'info',
	warn: 'warn',
	error: 'error',
	debug: 'debug',
}

const rawValue = process.env.NEXT_PUBLIC_NEXTJS_SERVER_ACTIONS_LOGGING;
const SERVER_LOGGING_ENABLED = rawValue?.toLowerCase() === 'true';

let isPatched = false

export function initConsoleBridge(): void {
	if (isPatched || typeof window === 'undefined') return
	isPatched = true

	const original: Partial<Record<ConsoleMethod, (...args: unknown[]) => void>> = {}
	const methods: ConsoleMethod[] = ['log', 'info', 'warn', 'error', 'debug']

	const consoleTyped: ConsoleLike = console

	for (const method of methods) {
		const originalMethod = consoleTyped[method].bind(console) as (...args: unknown[]) => void
		original[method] = originalMethod
		;(consoleTyped as ConsoleLike)[method] = ((...args: unknown[]) => {
			try {
        // Preserve original console behavior
        originalMethod(...args)

		if (SERVER_LOGGING_ENABLED) {
      const message = args.map(a => formatArg(a)).join(' ')
      clientLogger.custom(methodToLevel[method], message)
    }

      } catch (_err) {
        // Never throw from console bridge
      }
		}) as ConsoleLike[typeof method]
	}
}

function formatArg(value: unknown): string {
	try {
		if (typeof value === 'string') return value
		if (value instanceof Error) return `${value.name}: ${value.message}\n${value.stack ?? ''}`
		return JSON.stringify(value)
	} catch {
		return String(value)
	}
} 